<script lang="ts" setup>
import { ModalForm, IModalFormOptions } from '@components/ModalForm'
import { computed, ref } from 'vue'

import { useResponsive } from '../../composables/useResponsive'

import { useSettingsStore } from '@/stores/settingsStore'

const showModalFormRef = ref(false)
const settingsStore = useSettingsStore()
const title = computed(() => settingsStore.organizationName)
const { isMobile } = useResponsive()

const modalFormOptionsRef = ref<IModalFormOptions>({
  FormUuid: 'd56756a3-6345-494b-9ba7-71158b2c1362',
  FormTitle: 'Выбор основной организации',
  FormButtonTitle: 'Сохранить'
})

const handleModalSubmit = async () => {
  await settingsStore.loadSettings()
  showModalFormRef.value = false
}

const iconProps = {
  color: 'grey-darken-1',
  size: 32,
  class: 'mr-2',
  icon: 'mdi-domain'
}

</script>

<template>
  <div>
    <VBtn
      variant="text"
      @click="() =>showModalFormRef = true"
    >
      <VIcon v-bind="iconProps" />

      <span
        v-if="!isMobile"
        class="d-none d-lg-inline"
      >
        {{ title }}
      </span>
    </VBtn>
    <ModalForm
      v-if="showModalFormRef"
      v-model="showModalFormRef"
      :options="modalFormOptionsRef"
      max-width="500"
      @submit="handleModalSubmit"
    />
  </div>
</template>
